export interface PackDiff {
  added: string[]; // keys present only in next
  removed: string[]; // keys present only in prev
  changed: Array<{ key: string; prev: string; next: string }>;
}

export function diffStringBundles(
  prev: Record<string, string> | null | undefined,
  next: Record<string, string> | null | undefined,
): PackDiff {
  const p = prev ?? {};
  const n = next ?? {};
  const added: string[] = [];
  const removed: string[] = [];
  const changed: PackDiff["changed"] = [];
  for (const k of Object.keys(n)) {
    if (!(k in p)) added.push(k);
    else if (p[k] !== n[k]) {
      changed.push({ key: k, prev: p[k] ?? "", next: n[k] ?? "" });
    }
  }
  for (const k of Object.keys(p)) {
    if (!(k in n)) removed.push(k);
  }
  added.sort();
  removed.sort();
  changed.sort((a, b) => (a.key < b.key ? -1 : a.key > b.key ? 1 : 0));
  return { added, removed, changed };
}

export function diffIsEmpty(d: PackDiff): boolean {
  return d.added.length === 0 && d.removed.length === 0 && d.changed.length === 0;
}
